/*
创建者 李伟(2018.2.03)
*/
<template>
  <div class="conInner">
    <section id="content_wrapper">
      <div class="data">
        <h2>我的成长值</h2>
      </div>
      <div class="box">
        <div class="top"></div>
        <div class="body">
          <div class="empty" v-if="!getMyGrowthData.length">暂无信息</div>
          <table cellspacing="0" cellpadding="0" width="100%" v-if="getMyGrowthData.length">
            <thead>
            <tr>
              <th>创建时间</th>
              <th>类型</th>
              <th>描述</th>
              <th>成长值</th>
              <th>累计成长值</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="row in getMyGrowthData">
              <td>{{row.createTime}}</td>
              <td>{{row.typeValue}}</td>
              <td>{{row.content}}</td>
              <td>{{row.score}}</td>
              <td>{{row.total}}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="pager_border" v-if="getMyGrowthData.length">
          <Page ref="pages" :total="dataTotal" show-total :page-size="pageSize" @on-change="changepage" size="small"
                show-elevator></Page>
        </div>
        <div class="bottom"></div>
      </div>
    </section>
  </div>
</template>
<script>
  import {getMyGrowthList} from 'api/user.js';
  export default {
    data() {
      return {
        dataTotal: 0,
        pageSize: 10,
        getMyGrowthData: []
      }
    },
    created(){
      this.getMyGrowthList(1);
    },
    methods: {
      changepage(index){
        this.$refs['pages'].currentPage = index;
        this.getMyGrowthList(index);
      },
      getMyGrowthList: function (pageNo) {
        let _params = {
          'page': pageNo,
          'pageSize': this.pageSize
        }
        getMyGrowthList(_params).then((json) => {
          if (json.resCode == '1') {
            this.getMyGrowthData = json.data.list;
            this.dataTotal = json.data.total;
          } else {
            this.$Message.info(json.resDesc);
          }
        });
      }
    }
  }
</script>




// WEBPACK FOOTER //
// myGrowth.vue?97e051e0